<script src="edit-group-counseling.component.ts"></script>
<div class="container ">
  <h2 class="rounded mt-3 text-center">Group Update Session</h2>

<!--              <prettyjson [obj]="form.value"></prettyjson>-->



  <form [formGroup]="form">
    <div class="row">
      <mat-form-field appearance='outline' class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Centre Name']">info</mat-icon>

        <mat-label>AL Centre Name</mat-label>
        <input matInput aria-label="Default select example" formControlName="centres"
        />
        <mat-error *ngIf="centreSelect?.errors?.required">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance='outline' class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Child Name']">info</mat-icon>
        <mat-label>
          Child Name
        </mat-label>
        <input matInput aria-label="Default select example" formControlName="children"
        />
        <mat-error *ngIf="childSelect?.errors?.required">Required</mat-error>
      </mat-form-field>

      <!*--------------------------------------------- DATE--------------------------------------------->
      <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="form.controls.date?.errors?.required">Required</mat-error>

      </mat-form-field>
      <!*--------------------------------------------- Participants--------------------------------------------->
      <mat-form-field appearance='outline' class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Target Group']">info</mat-icon>

        <mat-label>
          Target Group
        </mat-label>

        <mat-select formControlName="participants">
          <mat-option value="Male">Male</mat-option>
          <mat-option value="Female">Female</mat-option>
          <mat-option value="Family">Family</mat-option>
          <mat-option value="Child">Child</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.sessionFor?.errors?.required">Required</mat-error>
      </mat-form-field>
      <!*--------------------------------------------- START TIME--------------------------------------------->
      <mat-form-field class="col-md-6 col-sm-12" appearance="outline">
        <mat-label>Session Start Time</mat-label>
        <!-- The timepicker input -->
        <input matTimepicker #t="matTimepicker" formControlName="startTime" [value]="startTime"
               [strict]="false" id="start-time-select" mode="12h"
               placeholder="Please select time..." name="time">
        <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
        <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
        <!-- Error that will be shown when the input date is invalid -->
        <!--            <mat-error *ngIf="eventTime?.touched && eventTime?.invalid">Invalid Date</mat-error>-->
        <mat-error *ngIf="form.controls.startTime?.errors?.required">Required</mat-error>

      </mat-form-field>
      <!*--------------------------------------------- END TIME--------------------------------------------->
      <mat-form-field class="col-md-6 col-sm-12" appearance="outline">
        <mat-label>Session End Time</mat-label>
        <!-- The timepicker input -->
        <input matTimepicker #t="matTimepicker" formControlName="endTime" [value]="endTime"
               [strict]="false" id="end-time-select" mode="12h"
               placeholder="Please select time..." name="time">
        <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
        <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
        <!-- Error that will be shown when the input date is invalid -->
        <!--            <mat-error *ngIf="eventTime?.touched && eventTime?.invalid">Invalid Date</mat-error>-->
        <mat-error *ngIf="form.controls.endTime?.errors?.required">Required</mat-error>

      </mat-form-field>
      <!--            <!*-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; Session Type-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
      <!--            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">-->
      <!--                <mat-label>Session Topic</mat-label>-->
      <!--                <mat-select  required formControlName="type">-->
      <!--                    <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>-->
      <!--                </mat-select>-->
      <!--            </mat-form-field>-->
      <!*--------------------------------------------- TOPIC COVERED--------------------------------------------->
      <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Session Topics']">info</mat-icon>

        <mat-label>Session Topic</mat-label>
        <mat-select formControlName="topicsCovered" multiple>
          <mat-option *ngFor="let t of _topiceCovered$|async" [value]="t">{{t}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.topicsCovered?.errors?.required">Required</mat-error>
      </mat-form-field>
      <!*--------------------------------------------- ISSUE--------------------------------------------->
      <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Issues']">info</mat-icon>
        <mat-label>Issue</mat-label>
        <textarea matInput formControlName="issue"></textarea>
        <mat-error *ngIf="form.controls.issue?.errors?.required">Required</mat-error>
      </mat-form-field>
      <!*--------------------------------------------- INTERVENTION--------------------------------------------->
      <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['interventions']">info</mat-icon>
        <mat-label>Intervention</mat-label>
        <textarea matInput formControlName="intervention"></textarea>
        <mat-error *ngIf="form.controls.intervention?.errors?.required">Required</mat-error>
      </mat-form-field>
      <!*--------------------------------------------- TAKEAWAY--------------------------------------------->
      <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
        <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Takeaway']">info</mat-icon>
        <mat-label>Takeaway</mat-label>
        <textarea matInput formControlName="takeaway"></textarea>
        <mat-error *ngIf="form.controls.takeaway?.errors?.required">Required</mat-error>
      </mat-form-field>
      <div class="d-flex justify-content-center">
        <button mat-raised-button color="warn" (click)="Cancel()">Cancel</button>&nbsp;&nbsp;
        <button mat-raised-button color="primary" type="submit" (click)="Submit()">Update</button>
      </div>
    </div>

  </form>
  <!--    SECTION TO SHOW PARENT NAMES-->
  <!--    <div>-->
  <!--        <h2>Parents name</h2>-->
  <!--        <span *ngFor="let c of selectedChildrens">-->
  <!--            <mat-card>-->
  <!--    <h3> {{c.childName}} {{c.parentsName}} </h3>&nbsp;&nbsp;-->

  <!--            </mat-card>-->
  <!--</span>-->
  <!--    </div>-->
  <!--------------------------------------------- CHILD OBJECTS --------------------------------------------->



</div>
